import * as Constants from '../../../helpers/Constants'
console.log(Constants.WIDTH)
const Styles = {
  homepalContainer: {
    width: 50,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1
  },
  homepalText: {
    fontFamily: 'Lato-Bold',
    fontSize: 38,
    textAlign: 'center'
  },
  abLawe: {
    width: Constants.WIDTH * 0.3,
    // height: Constants.WIDTH * 0.193 sbc
    // height: Constants.WIDTH * 0.0945
    // height: Constants.WIDTH * 0.333
    // height: Constants.WIDTH * 0.15
    // height: Constants.WIDTH * 0.274
    // height: Constants.WIDTH * 0.157,
    height: Constants.WIDTH * 0.098
  },
  castor: {
    width: Constants.WIDTH * 0.3,
    height: Constants.WIDTH * 0.086
  },
  default: {
    width: Constants.WIDTH * 0.3,
    height: Constants.WIDTH * 0.3
  },
  delagott: {
    width: '23%',
    height: '14%'
  },
  hsb: {
    width: Constants.WIDTH * 0.3,
    height: Constants.WIDTH * 0.3
  },
  riksbyggen: {
    width: Constants.WIDTH * 0.3,
    height: Constants.WIDTH * 0.127
  },
  sbc: {
    width: '18%',
    height: '14%'
  },
  wasabi: {
    width: Constants.WIDTH * 0.3,
    height: Constants.WIDTH * 0.157
  },
  salana: {
    width: '18%',
    height: '10%'
  },
  homepal: {
    width: '10%',
    height: '15%'
  },
  conzignus: {
    width: '13%',
    height: '9%'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/common/icon/styles.js